import urls, { apiBase } from './restConstants';
import csrfToken from './cookieUtils';

export const keepalive = () => (
  fetch(apiBase + '/' + urls.securityAccess.keepalive, { credentials: 'same-origin' })
);

export const authVerifier = () => (
  fetch(apiBase + '/' + urls.securityAccess.authVerifier, { credentials: 'same-origin' })
);

export const getUserInfo = () => (
  fetch(apiBase + '/' + urls.securityAccess.userInfo, { credentials: 'same-origin' })
);

export const authenticate = (credentials) => {
  const formData = new FormData();
  formData.append('username', credentials.username);
  formData.append('password', credentials.password);

  const headers = new Headers({
    'X-CSRF-TOKEN': csrfToken(),
  });

  return fetch('/api/' + urls.securityAccess.auth, {
    credentials: 'same-origin',
    method: 'POST',
    body: formData,
    headers,
  });
};

export const logout = () => {
  const headers = new Headers({
    'X-CSRF-TOKEN': csrfToken(),
  });

  return fetch(urls.securityAccess.logout,
        { credentials: 'same-origin', method: 'POST', headers });
};



// WEBPACK FOOTER //
// ./book/src/commons/rest/securityAccessRest.js